import { queryKeys } from "@/lib/useQuery/queryKeys";
import { useQuery } from "@tanstack/react-query";

export function useGetTablesList({
    baseId,
    apiKey
}: { baseId?: string, apiKey?: string }) {
    return useQuery({
        ...queryKeys.airtable.table(baseId!, apiKey!)._ctx.list,
        enabled: !!apiKey
    })
}